import { render, staticRenderFns } from "./bankArchiveTop.vue?vue&type=template&id=048cdf95&scoped=true"
import script from "./bankArchiveTop.vue?vue&type=script&lang=js"
export * from "./bankArchiveTop.vue?vue&type=script&lang=js"
import style0 from "./bankArchiveTop.vue?vue&type=style&index=0&id=048cdf95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048cdf95",
  null
  
)

export default component.exports